import Configuration from '@/agilis/util/Configuration'

export default {
  namespaced: true,
  state: {
    applications: {},
    workspaces: {},
    trackerTypes: {}
  },
  getters: {
    applications (state) {
      return state.applications
    },

    workspaces (state) {
      return state.workspaces
    },

    trackerTypes (state) {
      return state.trackerTypes
    }
  },
  mutations: {
    setApplications: function (state, applications) {
      state.applications = applications
    },

    setWorkspaces: function (state, workspaces) {
      state.workspaces = workspaces
    },

    setTrackerTypes: function (state, trackerTypes) {
      state.trackerTypes = trackerTypes
    }
  },

  actions: {
    setApplications (context) {
      if (!context.rootGetters['configurationStore/configurationLoadingCompleted'] ||
        context.rootGetters['userDataStore/userId'] == null) {
        return {}
      }
      const configApps = context.rootGetters['configurationStore/applications']
      const authApps = {}
      for (const appId in configApps) {
        if (Configuration.auth.userHasPrivilege(`/${appId}`)) {
          authApps[appId] = configApps[appId]
        }
      }
      context.commit('setApplications', authApps)
    },

    setWorkspaces (context) {
      const apps = context.state.applications
      const workspaces = []
      Object.entries(apps).map(([appId, app]) => {
        workspaces[appId] = Configuration.auth.getNestedWorkspaces(appId, app.workspaces, {})
      })
      context.commit('setWorkspaces', workspaces)
    },

    setTrackerTypes (context) {
      const apps = context.state.applications
      const workspaces = context.state.workspaces
      const trackerTypes = []
      Object.entries(apps).map(([appId]) => {
        trackerTypes[appId] = Object.entries(workspaces[appId]).map(([workspaceId]) => {
          return Configuration.auth.getTrackerTypes(appId, workspaceId)
        })
      })
      context.commit('setTrackerTypes', trackerTypes)
    }
  }
}
